import {
  ERROR,
  NEWUSER_SUB,
  RESPONSE_ERROR_LOGIN,
  SET_HEADER_PHOTO,
  GET_PROFILE_PHOTO,
  CLEAR_PROFILE_PHOTO,
} from "../types/index";
import * as api from "../api/index.js";
import { handleApiError } from "Helper";

export const getProfilePhoto = (docId) => async (dispatch) => {
  try {
    const profilePhoto = await api.getDocument(docId);
    dispatch({ type: GET_PROFILE_PHOTO, payload: profilePhoto.data.data });
  } catch (error) {
    if (error.response.status === 401) {
      dispatch({ type: RESPONSE_ERROR_LOGIN });
    }
    dispatch({ type: ERROR, payload: error });
  }
};

export const clearProfilePhoto = (docId) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_PROFILE_PHOTO });
  } catch (error) {
    dispatch({ type: ERROR, payload: error });
  }
};

export const setHeaderPhoto = (image) => async (dispatch) => {
  try {
    dispatch({ type: SET_HEADER_PHOTO, payload: image });
  } catch (error) {
    dispatch({ type: ERROR, payload: error });
  }
};

export const getUserClaims = () => async (dispatch) => {
  try {
    const datas = await api.getUserClaims();
    localStorage.setItem("url", datas.data.APIURL);
    dispatch({ type: NEWUSER_SUB, payload: datas.data });
  } catch (error) {
    handleApiError(error);
  }
};
